module.exports = __webpack_public_path__ + "graphics/icon-minecraft.ckh.eb003a7ab7088da637b051cdb56c1a0b.svg";